export default () => ({
	votesCount: {},
	votesCountId: null,
	votesCountPeriod: null,
	error: null,
});
